import { graphql } from '../../graphql';

export const sendAccessToken = graphql(`
  mutation Auth($accessToken: String!) {
    signIn(input: { accessToken: $accessToken }) {
      profile {
        ... on CompanyProfile {
          id
          name
          phone
        }
      }
      errors {
        message
        path
      }
    }
  }
`);

export const deleteCompany = graphql(`
  mutation SignOut {
    signOut {
      profile {
        ... on CompanyProfile {
          id
        }
      }
      errors {
        message
      }
    }
  }
`);

export const editProfileMutation = graphql(`
  mutation EditProfile(
    $name: String
    $email: String
    $alternativePhone: String
    $password: ProfileUpdatePasswordInput
  ) {
    updateProfile(
      input: {
        name: $name
        email: $email
        alternativePhone: $alternativePhone
        password: $password
      }
    ) {
      errors {
        code
        message
        path
      }
      status
      profile {
        ... on CompanyProfile {
          name
          email
          alternativePhone
        }
      }
    }
  }
`);

export const inviteAgentMutation = graphql(`
  mutation InviteAgent($email: String!) {
    inviteAgent(input: { email: $email }) {
      agent {
        id
        pendingEmail: email
      }
      status
      errors {
        message
        path
      }
    }
  }
`);

export const removeAgentMutation = graphql(`
  mutation RemoveAgent($id: ID!) {
    removeAgent(input: { id: $id }) {
      errors {
        message
        path
      }
    }
  }
`);

export const transferAgentBalanceMutation = graphql(`
  mutation TransferAgentBalance($input: [AgentTransferInput!]!) {
    transferAgentBalance(input: $input) {
      status
      errors {
        message
        path
      }
    }
  }
`);
